import React from 'react'
import PropTypes from 'prop-types'
import { Popper } from './Popper'

import parser from 'react-html-parser'

import BPopover from 'react-bootstrap/Popover'
import BFormLabel from 'react-bootstrap/FormLabel'
import { concatClasses } from '../../utils/fns'

const getLabelClasses = (className = '') => concatClasses('formGroup__title', className)

export const FormLabel = ({
  htmlFor,
  warning,
  popperText,
  popperImg,
  placement,
  children,
  className,
  ...props
}) => {
  const handleClose = () => {
    document.body.click()
  }

  return (
    <BFormLabel className={getLabelClasses(className)} htmlFor={htmlFor} {...props}>
      {children}
      {warning ? '*' : ''}
      {popperText && (
        <Popper
          overlay={
            <BPopover id={htmlFor} className="Popover">
              <div className="popoverClose" onClick={handleClose} />
              {popperImg && (
                <div className="popoverImg">
                  <img src={popperImg} />
                </div>
              )}
              {parser(popperText)}
            </BPopover>
          }
          placement={placement}
        />
      )}
    </BFormLabel>
  )
}

FormLabel.propTypes = {
  htmlFor: PropTypes.string,
  warning: PropTypes.bool,
  placement: PropTypes.oneOf([
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start',
  ]),
  popperText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  popperImg: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
}

FormLabel.defaultProps = {
  placement: 'top',
}
